import { Action } from '@ngrx/store';
import { AppSettingsDto } from '@app/generated/model';

export enum SettingsActionTypes {
  LoadSettings = '[Feature] Load Settings',
  LoadSettingsSuccess = '[Feature] Load Settings Success',
}

export class LoadSettings implements Action {
  readonly type = SettingsActionTypes.LoadSettings;
  constructor() {}
}

export class LoadSettingsSuccess implements Action {
  readonly type = SettingsActionTypes.LoadSettingsSuccess;

  constructor(public settingsDto: AppSettingsDto) {}
}

export type SettingsActions = LoadSettings | LoadSettingsSuccess;
